<template>
    <basic-modal
            @hide="close"
            v-model="opened"
            :aria-label="header"
            role="dialog"
    >
        <template #header>
            <div>
                <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
                <h3 class="modal-title"><i class="fa fa-lock" aria-hidden="true"></i> {{ header }}</h3>
            </div>
        </template>

        <div class="row">
            <div class="col-sm-12 gdpr-popup">
                <p>Your privacy is important to us.</p>
                <p>We work hard to keep your information safe and give you control over how it is shared.</p>

                <section class="gdpr-popup__section">
                    <h4>Privacy Policy</h4>
                    <p><a target="_blank" rel="noopener"
                          href="https://www.multime.com/our-privacy-policy">Read Privacy Policy<span
                            class="sr-only"> (opens in a new tab)</span></a>
                        <span class="gdpr-popup__divider" aria-hidden="true">|</span>
                        <a target="_blank" rel="noopener"
                           href="https://static1.squarespace.com/static/6aa16a0c51ae624521d70474/t/6aba4583015ebd15103c3ab2/1790592387095/4%2B-%2BLooking%2Bafter%2Byour%2Bpersonal%2Binformation.pdf">Easy
                            Read Version<span class="sr-only"> (opens in a new tab)</span></a></p>
                </section>

                <section class="gdpr-popup__section">
                    <h4>Cookies</h4>
                    <p>We use essential cookies to help Multi Me work properly.</p>
                    <p><a target="_blank" rel="noopener"
                          href="https://www.multime.com/our-cookie-policy">Read Cookie Policy<span
                            class="sr-only"> (opens in a new tab)</span></a></p>
                </section>
            </div>
        </div>
        <div class="row gdpr-popup__confirm">

            <div class="col-sm-12">
                <vue-switch-with-label
                        label="I confirm I have read the Privacy Policy."
                        name="agree_with_privacy_policy"
                        v-model="agree_with_privacy_policy"
                        class="inline-block"
                ></vue-switch-with-label>
            </div>

        </div>

        <template #footer>
            <div class="row">
                <div class="col-sm-12 text-right">
                    <button class="btn btn-mm btn-green" :disabled="!acceptIsPossible" @click="acceptPolicy">
                        Continue
                    </button>
                </div>
            </div>
        </template>
    </basic-modal>
</template>

<script>
    import PopupPromiseMixin from "../../../vue/mixins/PopupPromiseMixin";

    export default {
        name: "GDPRPopup",
        mixins: [PopupPromiseMixin],
        data() {
            return {
                header: "Your Privacy Matters",
                agree_with_privacy_policy: false
            }
        },
        computed: {
            acceptIsPossible() {
                return this.agree_with_privacy_policy;
            },
        },
        methods: {
            acceptPolicy() {
                this.save('ACCEPT');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use "styles/const.scss" as *;

    .gdpr-popup {
        font-size: $slight-bigger-font-size;
        line-height: 1.5;

        p {
            margin: 0 0 8px;
        }

        a {
            color: $menu-blue;
            font-weight: bold;
            text-decoration: underline;
        }

        &__section {
            margin-top: 20px;

            h4 {
                font-size: $bigger-font-size;
                font-weight: bold;
                margin: 0 0 6px;
            }
        }

        &__divider {
            margin: 0 8px;
        }
    }

    .gdpr-popup__confirm {
        margin-top: 16px;
        font-size: $slight-bigger-font-size;
    }
</style>
